import { isNilOrEmpty } from '@/utils/isNilOrEmpty';

export function formatMakeModelToUrlParam(make?: string | null, model?: string | null) {
  if (!isNilOrEmpty(make)) {
    return isNilOrEmpty(model) ? make.toLowerCase() : `${make.toLowerCase()}>${model.toLowerCase()}`;
  }

  return undefined;
}
